import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/allForOrderReportFilter`;

export const ROUTE: RouteDefinition = `${baseRoute}/allForOrderReportFilter`;

export const URL = (): RouteDefinition => `${baseRoute}/allForOrderReportFilter`;
